import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../services/data/data.service';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { TemplateService } from '../../../services/proyecciones/plantilla/template.service';
import { SelectTitleComponent } from '../../../components/select-title/select-title.component';
import { InstitucionService } from '../../../services/proyecciones/institucion/institucion.service';
import Swal from 'sweetalert2';
import { companiesRiesgoCredito } from '../../../shared/catalogos';
import { CuentaContableService } from '../../../services/proyecciones/cuenta-contable/cuenta-contable.service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { PeriodosSaldosService } from '../../../services/proyecciones/periodos-saldos/periodos-saldos.service';
import { SucursalService } from '../../../services/proyecciones/sucursal/sucursal.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-carga-informacion',
  templateUrl: './carga-informacion.component.html',
  styleUrl: './carga-informacion.component.css'
})
export class CargaInformacionComponent {
  @ViewChild(SelectTitleComponent) titleSelect!: SelectTitleComponent;
  public plantilla;
  public instSelecc: any = {id: 0, alias: ''};
  private  templateId = undefined;
  private institucionId = undefined;
  public dataPlantillas = [];  
  public inst = [];
  private dataContable = [];
  public dataSucursales = [];
  public sucursalSelect;
  public encabezados = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
  public listPeriodos = [];
  public selectedFiles;
  private dataSaldosMes = [];

  constructor(
    public cookies: CookieService,
    public dataService: DataService,
    private translate: TranslateService,
    private plantillas: TemplateService,
    private excelservices: ExcelService,
    private cuentaContable: CuentaContableService,
    private instituciones: InstitucionService,
    private sucursales: SucursalService,
    private periodoSaldo: PeriodosSaldosService,
  ){
    this.templateId = Number(cookies.get('templateId'));
    this.institucionId = cookies.get('idInstitucionProy');
    this.getInstituciones();
  }
  public async getInstituciones(){//lista todas las instituciones con una platilla activa
    try{
      const res = await firstValueFrom(this.instituciones.getInstucionesTemplateActivo());
      this.inst = res;
      const instId = this.dataService.idInstitution;
      if(this.institucionId){
        this.instSelecc = this.inst.filter(i => i.institutionid == this.institucionId)[0];
        this.getCuentasContables();
        await this.getSucursales();
        await this.getPeriodos();
        this.getPeriodosSucursal();
        return;
      }
      this.selectInst();
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  public async selectInst(){
    const instId = this.dataService.idInstitution;
    const role = this.dataService.role.toLowerCase();
    const insti = this.inst
      .filter( i => i.alias !== null)
      .reduce((i, item) => {
      i[item.institutionid] = item.alias;
      return i;
    }, {})
    if(role.includes('administrador')){

      const result = await messages.select(
        this.translate.instant('Seleccione una institución'),
        insti,
        this.translate
      );
      if(result){
        this.instSelecc = this.inst.filter(i => i.institutionid == result)[0];
        this.cookies.set('idInstitucionProy',this.instSelecc.institutionid, {path: '/'});
        this.institucionId = this.instSelecc.institutionid;
        this.getCuentasContables();
        await this.getSucursales();
        await this.getPeriodos();
        this.getPeriodosSucursal();
      }
    }else{
      // TODO falta validar el funcionamiento con un usuario que no sea admi
      try{
        const res = await firstValueFrom(this.instituciones.getInstitucionIdAdmi(instId));
        this.instSelecc = this.inst.find(i => i.institutionid == res?.[0]?.id) ?? null;
        if(this.instSelecc){
          this.cookies.set('idInstitucionProy',this.instSelecc.institutionid, {path: '/'});
          this.institucionId = this.instSelecc.institutionid;
          this.getCuentasContables();
          await this.getSucursales();
          this.getPeriodosSucursal();
        }else{
          messages.infoMessageGraph(this.translate.instant('proyFinanciera.cargaInformacion.noPlantilla'))
        }
      }catch(e){
        messages.errorMessageGraph(e.error);
      }
    }
  }
  private async getCuentasContables() { 
    try{
      const res = await firstValueFrom(this.cuentaContable.getCuentas(this.instSelecc.templates[0].templateid));
      this.dataContable = res;
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  private async getSucursales(){
    try{
      const res = await firstValueFrom(this.sucursales.getSucursales(this.institucionId));
      this.dataSucursales = res;
      this.sucursalSelect = this.dataSucursales.find(i=>i.consolidado);
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  public descargarArchivo(){
    messages.messageSaving(this.translate.instant('swal.generando'), this.translate.instant('swal.espere'))
    var titulos = [], alineacion = [], formato = [], data = [];
    var tituloHoja = '', nombreArch = 'Cuentas';
    alineacion = [Aligment.RIGHT, Aligment.LEFT,Aligment.LEFT];
    formato = [FormatText.TEXT,FormatText.TEXT,FormatText.NUMBER];
    titulos = [
      this.translate.instant('proyFinanciera.cargaInformacion.tit1'),
      this.translate.instant('proyFinanciera.cargaInformacion.tit2'),
      this.translate.instant('proyFinanciera.cargaInformacion.tit3'),
    ]
    for(let i of this.dataContable){
      var aux = [];
      aux.push(i.codigo);
      aux.push(i.nombre);
      data.push(aux);
    }
    this.excelservices.generateExcelSinTitulo(titulos,data,nombreArch, alineacion,formato);
    messages.succesMessageGraph(this.translate.instant('swal.descargaExi'));
  }
  private async getPeriodos(){
    try{
      const res = await firstValueFrom(this.periodoSaldo.getPeriodosAgrupAnio());
      const nombres = ["ene", "feb", "mar", "abr", "may", "jun",
        "jul", "ago", "sep", "oct", "nov", "dic"];

      const resultado = Object.entries(res).map(([an, meses]) => {
        const monthsArray: number[] = Array.isArray(meses) ? (meses as number[]) : [];
        return {
          anio: Number(an),
          meses: Array.from({ length: 12 }, (_, i) => {
            const monthNumber = i + 1;
            return {
              mes: monthNumber,
              nombreMes: `${nombres[i]}-${an}`,
              activo: false,
            };
          })
        };
      });
      this.listPeriodos = resultado;
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  private async getPeriodosSucursal(){
    try{
      const res = await firstValueFrom(this.periodoSaldo.getPeriodosSucursal(this.institucionId, this.sucursalSelect.sucursalid));
      const anios = Object.keys(res);
      this.listPeriodos.forEach(per => {
        const an = String(per.anio);
        if(res[an]){
          per.meses = per.meses.map(mes => ({
            ...mes,
            activo: res[an].includes(mes.mes)
          }))
        }
      })
    }catch(e){
      // messages.errorMessageGraph(e.error);
    }
  }
  public async accionesPeriodo(anio: number, mes){
    try{
      if(mes.activo){//Ya existe informacion y se desea descargar
        messages.messageSaving(this.translate.instant('swal.generando'), this.translate.instant('swal.espere'))
        const res = await firstValueFrom(this.periodoSaldo.getSaldosPeriodo(this.institucionId, this.sucursalSelect.sucursalid, anio, mes.mes ))
        this.dataSaldosMes = res.periodo.saldos;
        this.exportarSaldos(mes);
      }else{// no hay informacion para este periodo y se desea cargar 
        let introdujo: any;
        introdujo = await Swal.fire({
          title: ''+ this.translate.instant('proyFinanciera.configCatalogo.selecArch'),
          text: "",
          input: 'file',
              
          inputAttributes: {
            "accept": ".xlsx",
            "aria-label": "Upload your profile picture"
          },
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('menu.acep'),
          cancelButtonText: this.translate.instant('menu.cancel'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return this.translate.instant('proyFinanciera.configCatalogo.selecArch');
            }
            return '';
          }
        });        
        this.selectedFiles = introdujo.value;
        var reader = new FileReader();
        reader.readAsDataURL(this.selectedFiles);
        reader.onload = (e) => {
          let data = reader.result;
          this.obtBuffer(data, anio, mes);
        }
      }
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  private async obtBuffer(data, anio, mes){
    messages.messageSaving(this.translate.instant('proyFinanciera.configCatalogo.verificandoArch'), this.translate.instant('swal.espere'));
    const file = await fetch(data)
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const rawsData: any = XLSX.utils.sheet_to_json(worksheet, {header: 1});
    
    if(rawsData[0][0] == 'Codigo'){ // eliminamos el primer renglon de encabezados
      rawsData.shift();
    }
    if(this.verificarSaldos(rawsData) === 0){ //archivo correcto
      for(const d of rawsData){
        this.dataSaldosMes.push({
          codigo: d[0],
          nombre: d[1],
          saldo: d[2],
        })
      }
      try{
        const res = await firstValueFrom(this.periodoSaldo.postSaldosPeriodo(Number(this.institucionId), this.sucursalSelect.sucursalid, anio, mes.mes, this.dataSaldosMes))
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('swal.infoGuardado'));
        await this.getPeriodos();
        this.getPeriodosSucursal();
      }catch(e){
        messages.errorMessageGraph(e.error);
      }
    }    
  }
  private isNumber(n){
    return typeof n === "number";
  }
  private verificarSaldos(data){
    //verificar la columna de saldos sea numerica 
    var p = 0;
    for(const row of data){
      if(row.length !== 0){
        if(row[0] === undefined){// || !this.isNumber(row[2])){
          let texto = this.translate.instant('proyFinanciera.cargaInformacion.saldoInv');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        if(row[1] === undefined){// || !this.isNumber(row[2])){
          let texto = this.translate.instant('proyFinanciera.cargaInformacion.saldoInv');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        if(row[2] === undefined || !this.isNumber(row[2]) ){// || !this.isNumber(row[2])){
          let texto = this.translate.instant('proyFinanciera.cargaInformacion.saldoInv');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
      }
      p++;
    }
    return 0;
  }
  public async cambiarTab(event){
    if(event.index === 0){
      this.sucursalSelect = this.dataSucursales.find(i=>i.consolidado);
      await this.getPeriodos();
      this.getPeriodosSucursal();
  }else{
      this.sucursalSelect = undefined;
    }
  }
  public async cambiarSucursal(event){
    this.sucursalSelect = event.value
    await this.getPeriodos();
    this.getPeriodosSucursal();
  }

  private exportarSaldos(periodo){
    var titulos = [], alineacion = [], formato = [], data = [];
    var tituloHoja = '', nombreArch = '';
    var suc = `${this.translate.instant('proyFinanciera.cargaInformacion.archSuc')} ${this.sucursalSelect.nombre} | ${periodo.nombreMes}`;
    var con = `${this.translate.instant('proyFinanciera.cargaInformacion.archCon')} ${this.sucursalSelect.nombre} | ${periodo.nombreMes}`;
    tituloHoja = this.sucursalSelect.consolidado ? con : suc;
    nombreArch = `${this.translate.instant('proyFinanciera.cargaInformacion.archCon')} ${periodo.nombreMes}`;
    alineacion = [Aligment.RIGHT, Aligment.LEFT,Aligment.LEFT];
    formato = [FormatText.TEXT,FormatText.TEXT,FormatText.NUMBER];
    titulos = [
      this.translate.instant('proyFinanciera.cargaInformacion.tit1'),
      this.translate.instant('proyFinanciera.cargaInformacion.tit2'),
      this.translate.instant('proyFinanciera.cargaInformacion.tit3'),
    ]
    for(const d of this.dataSaldosMes){
      var aux = [];
      aux.push(d.codigo);
      aux.push(d.nombre);
      aux.push(d.saldo);
      data.push(aux);
    }
    this.excelservices.generateExcel(tituloHoja,titulos,data,nombreArch, alineacion,formato);
    messages.succesMessageGraph(this.translate.instant('swal.descargaExi'));
  }

}
